import { SubscribeModalPlanType, SubscribeModalMode } from './state';
import { SubscriptionPaymentStart } from '../../PaymentTransaction/SubscriptionTransaction/actions';
import { CourseAccessDeniedAction } from '../../Courses/actions';

export const SUBSCRIBE_MODALS_SHOW_PRICING_MODAL =
  'SUBSCRIBE_MODALS_SHOW_PRICING_MODAL';
export const SUBSCRIBE_MODALS_CLOSE_PRICING_MODAL =
  'SUBSCRIBE_MODALS_CLOSE_PRICING_MODAL';
export const SUBSCRIBE_MODALS_PRICING_LINK_CLICK =
  'SUBSCRIBE_MODALS_PRICING_LINK_CLICK';
export const SUBSCRIBE_MODALS_START_TRIAL_CLICK =
  'SUBSCRIBE_MODALS_START_TRIAL_CLICK';

export type SubscribeModalShowPricingModal = {
  type: 'SUBSCRIBE_MODALS_SHOW_PRICING_MODAL';
  planType: SubscribeModalPlanType;
  canDismiss: boolean;
  mode: SubscribeModalMode;
};

export type SubscribeModalClosePricingModal = {
  type: 'SUBSCRIBE_MODALS_CLOSE_PRICING_MODAL';
  planType: SubscribeModalPlanType;
};

export type SubscribeModalStartTrialClick = {
  type: 'SUBSCRIBE_MODALS_START_TRIAL_CLICK';
  eventData: {
    subscriptionName: string;
  };
};

export type SubscribeModalsAction =
  | SubscribeModalShowPricingModal
  | SubscribeModalClosePricingModal
  | SubscribeModalStartTrialClick
  | SubscriptionPaymentStart
  | CourseAccessDeniedAction;
